// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1SavePatientDefaultResponseData {
    static getAttributeTypeMap() {
        return HubV1SavePatientDefaultResponseData.attributeTypeMap;
    }
}
HubV1SavePatientDefaultResponseData.discriminator = undefined;
HubV1SavePatientDefaultResponseData.additionalProperties = false;
HubV1SavePatientDefaultResponseData.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
];
//# sourceMappingURL=hubV1SavePatientDefaultResponseData.js.map